import { VuexModule, Module, Action } from "vuex-class-modules";
import AppConfig from "@/config/application.config";
import store from "@/store";
import { Routes } from "@/router/Routes";
import { Location } from "vue-router/types/router";

export class Error {
  constructor(
    public title: string,
    public status?: number,
    public errorDetails?: string
  ) {}
}

export class BreadCrumb {
  disabled = false;
  exact = true;

  constructor(
    public text: string,
    public to: Location = {
      name: Routes.LOGIN,
    }
  ) {}
}

@Module({ generateMutationSetters: true })
class GlobalStore extends VuexModule {
  version = AppConfig.Version;
  isBusy = false;
  error: Error | null = null;
  breadCrumbs: BreadCrumb[] = [];
  title = "Loading...";
  isWelcomePage = false;

  @Action
  setError(error: Error) {
    this.error = error;
  }

  @Action
  setIsBusy(value: boolean) {
    this.isBusy = value;
  }

  @Action
  setBreadCrumbs(value: BreadCrumb[]): void {
    if (value.length > 0) {
      value[value.length - 1].disabled = true;
      this.breadCrumbs = value;
    }
  }

  @Action
  setTitle(value: string): void {
    if (value) {
      this.title = value;
    }
  }

  @Action
  setWelcomeBackFlag(value: boolean): void {
    this.isWelcomePage = value;
  }
}

export const globalStore = new GlobalStore({ store, name: "global" });
